export const HIDDEN_TEAM_NAMES = ['maatschappelijke transities']

export const isHiddenTeam = name => {
  if (!name) return false
  const normalized = String(name)
    .replace(/\s*\(nieuw\)\s*$/i, '')
    .trim()
    .toLowerCase()
  return HIDDEN_TEAM_NAMES.includes(normalized)
}
